import ReportCustemTableDetails from "Component/CustomTable/reportCustemTableDetails";
import { useState, useEffect, useRef, useMemo } from "react";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { TablePagination } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import isEqual from "lodash/isEqual";
import { ubahStripKeSpasi } from "DashboardManagementPlatform/Helper";
import { getMasterOrganisasi } from "slice/masterSlice";
import { handleError, handleErrorGlobal } from "Helper";

export const ReportDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const detailData = location.state;
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const isFiltersInitialized = useRef(false);
  const isFiltersInitializedDetail = useRef(false);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";

  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);

  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filterReports, setFilterReports] = useState([]);
  // console.log(isLoading, "isLoading");

  const [keywordSearchDetail, setDataKeywordDetail] = useState("");
  const [pageNumberDetail, setPageNumberDetail] = useState(0);
  const [pageSizeDetail, setPageSizeDetail] = useState(5);
  const [dataDetail, setDataDetail] = useState({});

  const [headerTable] = useState([
    {
      label: "Nama",
      key: "nama_target",
      align: "left",
    },
    {
      label: "Nik",
      key: "nik_target",
      align: "center",
    },
    {
      label: "Gender",
      key: "gender_target",
      align: "center",
    },
    {
      label: "Gambar Crop",
      key: "crop_image",
      align: "center",
    },
    {
      label: "Full Capture",
      key: "full_frame",
      align: "center",
    },
    {
      label: "Gambar Target",
      key: "person_face",
      align: "center",
    },
    {
      label: "Similarity",
      key: "similarity",
      align: "center",
    },
    {
      label: "IsDpo",
      key: "is_dpo",
      align: "center",
    },
    {
      label: "Tanggal Report",
      key: "dateDetected",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: false,
    isEdit: false,
    isShow: false,
    isDelete: false,
    isSearch: false,
  });

  const detailCamera = dataDetail?.data?.find(
    (item) => item?.report?.uuid === id
  );

  let valueStartDate =
    filterReports[0]?.value === undefined ? null : filterReports[0]?.value;
  let valueEndDate =
    filterReports[1]?.value === undefined ? null : filterReports[1]?.value;
  let valueIsDpo =
    filterReports[2]?.value?.value === undefined
      ? ""
      : filterReports[2]?.value?.value;

  const handleFilterReportChange = (key, newValue) => {
    setFilterReports((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };

  const getDataDetails = async () => {
    try {
      setIsLoading(true);

      const paramCari = `keywords=${keywordSearchDetail}`;
      const paramPage = `page=${pageNumberDetail}`;
      const paramSize = `size=${pageSizeDetail}`;
      const paramisDpo = `isDpo=${valueIsDpo}`;
      const paramstartDate = `startDate=${valueStartDate}`;
      const paramendDate = `endDate=${valueEndDate}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? "" : organisasi_user_id}`;
      // console.log("zzy");
      let route;
      if (valueStartDate && valueEndDate) {
        route = `/report-detected-target/get-report-detected?reportUuid=${id}&${paramisDpo}&${paramCari}&${paramstartDate}&${paramendDate}&${paramPage}&${paramSize}`;
      } else {
        route = `/report-detected-target/get-report-detected?reportUuid=${id}&${paramisDpo}&${paramCari}&${paramPage}&${paramSize}`;
      }

      const response = await fetchApi().get(route);
      // const response = await fetchApi().get(
      //   `/report-detected-target/get-report-detected?reportUuid=${id}&${paramisDpo}&${paramCari}&=${paramstartDate}$${paramendDate}&${paramPage}&${paramSize}`
      // );
      setDataDetail(response?.data || {});
      setPageNumberDetail(response.data?.currentPage || 0);
      setPageSizeDetail(response.data?.size || 15);
      setIsLoading(false);
      setError(false);
    } catch (err) {
      setError(true);
      setDataDetail([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    if (id && isFiltersInitializedDetail.current) {
      if (
        (valueStartDate === null && valueEndDate === null) ||
        (valueStartDate !== null && valueEndDate !== null)
      ) {
        getDataDetails();
      }
    } else {
      const reset = filterReports.map((f) => ({
        ...f,
        value: f.multiple ? [] : null,
      }));
      if (!isEqual(filterReports, reset)) {
        setFilterReports(reset);
      }
    }
  }, [
    id,
    filterReports,
    pageNumberDetail,
    pageSizeDetail,
    valueStartDate,
    valueEndDate,
  ]);
  // ==================== Default ==================== //
  const datafilterReports = useMemo(() => {
    const baseFilterReports = [
      {
        key: "startDate",
        label: "Start Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "endDate",
        label: "End Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "is_active",
        type: "autocomplite",
        label: "Status",
        isLoading: false,
        options:
          [
            { label: "DPO", value: true },
            { label: "NON DPO", value: false },
            // { label: "All", value: null },
          ] || [],
        multiple: false,
        value: null,
      },
    ];

    return baseFilterReports;
  }, []);

  useEffect(() => {
    if (datafilterReports.length > 0 && !isFiltersInitializedDetail.current) {
      const mapped = datafilterReports.map((f) => ({
        ...f,
        value: f.multiple ? [] : null,
      }));
      setFilterReports(mapped);
      isFiltersInitializedDetail.current = true;
    }
  }, [datafilterReports]);

  return (
    <div>
      <div className=" flex text-lg font-bold text-start gap-4 pb-5 items-center justify-between">
        <p
          className="text-2xl "
          style={{
            fontFamily: "Poppins",
          }}
        >
          {error ? (
            <div className="flex items-center gap-2">
              <h2 className="text-gray-800">Ada Kesalahan! </h2>
            </div>
          ) : !detailCamera?.report ? (
            <div className="flex flex-col gap-1">
              {/* <div className="h-6 w-48 bg-gray-200 animate-pulse rounded" /> */}
              {/* <div className="h-7 w-96 bg-gray-200 animate-pulse rounded" /> */}
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <h2 className="text-gray-800">
                Detail Data -{" "}
                <span>
                  {detailCamera?.report?.name_camera === null
                    ? "Tidak Diketahui"
                    : ubahStripKeSpasi(detailCamera?.report?.name_camera)}
                </span>
              </h2>
              <p className="text-sm text-gray-700">
                (
                {detailCamera?.report?.is_ip_camera ? (
                  <span className="font-medium">Realtime Monitoring</span>
                ) : (
                  <span className="font-medium">Playback</span>
                )}
                {" - "}
                <span className="font-medium">
                  {detailCamera?.report?.report_organization === null
                    ? "Tidak Diketahui"
                    : detailCamera?.report?.report_organization}
                </span>
                )
              </p>
            </div>
          )}
        </p>
      </div>

      <div>
        <ReportCustemTableDetails
          params={{
            pageNumberDetail,
            pageSizeDetail,
            valueStartDate,
            valueEndDate,
            valueIsDpo,
            id,
          }}
          targets={dataDetail?.data}
          detailData={detailData}
          error={error}
          filtersConfig={datafilterReports}
          filters={
            filterReports?.length === 0 ? datafilterReports : filterReports
          }
          handleFilterChange={handleFilterReportChange}
          sxCustem={(f) => (f?.type === "date" ? 300 : 200)}
          onClickCreate={() => navigate(ROUTES.report.report_create)}
          isAction={isActionTable}
          onEditData={(data) =>
            navigate(ROUTES.report.report_update, {
              state: data,
            })
          }
          onClickShow={(data) => {
            // setDetailData(data);
            setOpenModal(!openModal);
          }}
          onDeleteData={(data) => {
            setOpenModalDelete(!openModalDelete);
          }}
          isLoading={
            error
              ? isLoading
              : dataDetail?.data === undefined
                ? true
                : isLoading
          }
          headerData={headerTable}
          Data={dataDetail?.data || []}
          onSearchData={(keyword) => {
            setDataKeywordDetail(keyword);
          }}
          rowsPerPage={pageSizeDetail}
          page={pageNumberDetail}
          TablePagination={
            <TablePagination
              rowsPerPageOptions={[5, 15, 30, 50]}
              component="div"
              count={dataDetail?.totalItems || 0}
              rowsPerPage={pageSizeDetail}
              page={pageNumberDetail}
              onPageChange={(event, newPage) => {
                setPageNumberDetail(newPage);
              }}
              onRowsPerPageChange={(event) => {
                setPageSizeDetail(event.target.value);
              }}
            />
          }
        />
      </div>
    </div>
  );
};
